import { computed, toValue, useSlots, type ComputedRef, type MaybeRefOrGetter } from 'vue'

/** FieldFrame bindings and the caller's provided slots among `slotNames`, shared by every field molecule. */
export const useFieldFrame = <SlotName extends 'help' | 'label'>(
  source: {
    name: MaybeRefOrGetter<string>
    label: MaybeRefOrGetter<string>
    hint: MaybeRefOrGetter<string>
    help: MaybeRefOrGetter<string>
    required: MaybeRefOrGetter<boolean>
  },
  message: MaybeRefOrGetter<string>,
  slotNames: readonly SlotName[]
): {
  frameBindings: ComputedRef<{
    name: string
    label: string
    hint: string
    help: string
    required: boolean
    message: string
  }>
  forwardedFieldSlots: () => SlotName[]
} => {
  const slots = useSlots()
  const frameBindings = computed(() => ({
    name: toValue(source.name),
    label: toValue(source.label),
    hint: toValue(source.hint),
    help: toValue(source.help),
    required: toValue(source.required),
    message: toValue(message)
  }))
  // Slots are not reactive, so the names are read at render time.
  const forwardedFieldSlots = (): SlotName[] =>
    slotNames.filter((slotName) => slots[slotName] !== undefined)
  return { frameBindings, forwardedFieldSlots }
}
